interface SlideFiveProps {
  donationString: string;
}

export const SlideFive = ({ donationString }: SlideFiveProps) => {
  return (
    <div class="slide slide-five">
      <div class="header">
        <img src={`https://${import.meta.env.VITE_MEDIA_HOST}/dollar-sign.svg`} alt="Dollar Sign" />
        <div>Free {donationString} Donation After Checkout</div>
      </div>
      <div class="center-content">
        It costs <strong>nothing</strong> to spread more love.
      </div>
      <div class="footer">
        <strong>Donations are Covered!</strong>
        <div>Donations are sponsored by major donors and can be unlocked for free after your purchase. Donations are settled quarterly and paid to the benefiting charity, an IRS-registered 501(c)(3) public charity.</div>
      </div>
    </div>
  );
};
